import { AxiosRequestConfig } from 'axios';

import store from 'core/Store/Store';

export default function authHeaderInterceptor(request: AxiosRequestConfig) {
  const { token } = store.getState().auth;

  if (token) {
    request.headers.Authorization = 'Bearer ' + token;
  }

  return request;
}
